import { type NotificationPreferences } from '@choco-admin/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '../../../../../../../components/FormComponents';

export const MessagingNotifications: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<NotificationPreferences>();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Messaging Notifications</h3>

      <div className="space-y-4">
        <Input
          id="whatsappNumber"
          label="WhatsApp Number"
          {...register('sms.orderUpdates')}
          errorMessage={errors.sms?.orderUpdates?.message}
          isInvalid={!!errors.sms?.orderUpdates}
          className="max-w-md"
          onChange={(value) => {
            const event = { target: { value } };
            register('sms.orderUpdates').onChange(event);
          }}
        />

        <Input
          id="smsNumber"
          label="SMS Number"
          {...register('sms.emergencyAlerts')}
          errorMessage={errors.sms?.emergencyAlerts?.message}
          isInvalid={!!errors.sms?.emergencyAlerts}
          className="max-w-md"
          onChange={(value) => {
            const event = { target: { value } };
            register('sms.emergencyAlerts').onChange(event);
          }}
        />
      </div>
    </div>
  );
};
